import { ProductCollectionSlice } from '../../../types';
import { SET_PRODUCT_COLLECTION_LAYOUT } from '../actions';
import { PRODUCT_COLLECTION_LAYOUT } from '../constants';
import { LayoutMode } from '../types';

type State = {
  collectionDefaultLayout: LayoutMode;
  userSelectedLayout?: LayoutMode;
};

export default (state: State | undefined, action: any): State => {
  if (!state) {
    return {
      collectionDefaultLayout: LayoutMode.GRID,
    };
  }

  switch (action.type) {
    case 'ROUTE_LOADED': {
      const productsSlice = action.data?.productCollection?.slices.find(
        (slice: ProductCollectionSlice) => slice.__typename === 'ProductsSlice'
      );

      return {
        ...state,
        collectionDefaultLayout:
          productsSlice?.preferredViewMode === LayoutMode.GRID
            ? LayoutMode.GRID
            : LayoutMode.LIST,
      };
    }

    case SET_PRODUCT_COLLECTION_LAYOUT:
      return {
        ...state,
        userSelectedLayout: action.layout,
      };

    case 'LOCAL_STORAGE_RECEIVE': {
      const productCollectionLayoutFromLocalStorage =
        action.localStorageState[PRODUCT_COLLECTION_LAYOUT];
      return {
        ...state,
        userSelectedLayout: productCollectionLayoutFromLocalStorage,
      };
    }
    default:
      break;
  }

  return state;
};
